import { render, staticRenderFns } from "./ActionSettingsItem.vue?vue&type=template&id=56d11ea8&scoped=true&"
import script from "./ActionSettingsItem.vue?vue&type=script&lang=js&"
export * from "./ActionSettingsItem.vue?vue&type=script&lang=js&"
import style0 from "./ActionSettingsItem.vue?vue&type=style&index=0&id=56d11ea8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d11ea8",
  null
  
)

export default component.exports